/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnfilteredTagPartialUpdate
 */
export interface UnfilteredTagPartialUpdate {
    /**
     * 
     * @type {Array<number>}
     * @memberof UnfilteredTagPartialUpdate
     */
    roots?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof UnfilteredTagPartialUpdate
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UnfilteredTagPartialUpdate
     */
    shared?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UnfilteredTagPartialUpdate
     */
    color?: string;
}

export function UnfilteredTagPartialUpdateFromJSON(json: any): UnfilteredTagPartialUpdate {
    return UnfilteredTagPartialUpdateFromJSONTyped(json, false);
}

export function UnfilteredTagPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnfilteredTagPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'roots': !exists(json, 'roots') ? undefined : json['roots'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'shared': !exists(json, 'shared') ? undefined : json['shared'],
        'color': !exists(json, 'color') ? undefined : json['color'],
    };
}

export function UnfilteredTagPartialUpdateToJSON(value?: UnfilteredTagPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'roots': value.roots,
        'name': value.name,
        'shared': value.shared,
        'color': value.color,
    };
}


